import { PlacementStatusEnum, useGetLiveContentHeroBannerQuery } from 'domains/merchandising/api'

interface HeroBannerSearchArgs {
  retailerId: string
}

export const useGetLiveHeroBanner = ({ retailerId }: HeroBannerSearchArgs) => {
  const { data, error, loading } = useGetLiveContentHeroBannerQuery({
    fetchPolicy: 'cache-and-network',
    variables: {
      retailerId,
      filter: {
        status: PlacementStatusEnum.Live,
      },
      limit: 1,
    },
  })

  let banners = []

  if (data?.storefrontPlacementSearch?.edges?.length) {
    banners = data.storefrontPlacementSearch.edges.map(({ node }) => node)
  }

  return {
    banners,
    apiResult: data?.storefrontPlacementSearch,
    apiSuccess: Boolean(data),
    apiLoading: loading,
    apiError: error,
  }
}
